(() => {
  const MESSAGE_HTML = `
    <div class="preorder-note" style="margin-top:12px;font-size:14px;line-height:1.4;">
      <strong>Prekė išparduota.</strong>
      Galimas išankstinis užsakymas el. paštu:
      <a href="mailto:info@sarunevaitkute.com" style="font-weight:600;text-decoration:underline;">
        info@sarunevaitkute.com
      </a>
    </div>
  `;

  function getButton() {
    return document.querySelector('.product-form__buttons button[name="add"].product-form__submit');
  }

  function getButtonsWrap() {
    return document.querySelector(".product-form__buttons");
  }

  function removeMessage() {
    document.querySelector(".preorder-note")?.remove();
  }

  function showMessage() {
    const wrap = getButtonsWrap();
    if (!wrap) return;
    if (!document.querySelector(".preorder-note")) {
      wrap.insertAdjacentHTML("afterend", MESSAGE_HTML);
    }
  }

  function update() {
    const btn = getButton();
    if (!btn) {
      removeMessage();
      return;
    }

    // true "sold out" usually disables the button
    const isDisabled =
      btn.hasAttribute("disabled") ||
      btn.getAttribute("aria-disabled") === "true" ||
      btn.classList.contains("sold-out") ||
      btn.classList.contains("disabled") ||
      btn.classList.contains("is-disabled");

    // prevent the brief flash on in-stock products
    const text = (btn.textContent || "").trim().toLowerCase();
    const looksAvailable = text.includes("krep") || text.includes("add");

    if (isDisabled && !looksAvailable) {
      showMessage();
    } else {
      removeMessage();
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    update();

    // hide message immediately when adding to cart
    document.addEventListener("submit", () => removeMessage(), true);
    document.addEventListener("click", (e) => {
      if (e.target?.closest?.('.product-form__buttons button[name="add"]')) removeMessage();
    }, true);

    // keep in sync on variant changes / theme rerenders
    document.addEventListener("change", () => setTimeout(update, 80));
    window.addEventListener("popstate", () => setTimeout(update, 80));
    new MutationObserver(() => setTimeout(update, 80)).observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();
